import { OnInit } from "@angular/core";
var UserblockComponent = /** @class */ (function () {
    function UserblockComponent(userblockService, settings) {
        this.userblockService = userblockService;
        this.settings = settings;
    }
    UserblockComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.settings.getUserProfile().subscribe(function (a) { return _this.user = a; });
    };
    UserblockComponent.prototype.getUserImage = function () {
        if (this.user != null && this.user.picture != null)
            return this.user.picture;
        return "assets/img/dummy.png";
    };
    UserblockComponent.prototype.userBlockIsVisible = function () {
        return this.userblockService.getVisibility();
    };
    return UserblockComponent;
}());
export { UserblockComponent };
